import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle, RefreshCw, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import api from '../lib/api';

const PagamentoErroPage = () => {
  const [searchParams] = useSearchParams();
  const participanteId = searchParams.get('ref') || searchParams.get('external_reference');

  const handleRetry = async () => {
    if (!participanteId) {
      window.location.href = '/';
      return;
    }

    try {
      // Use axios instead of fetch to avoid body stream issues
      const response = await api.post('/payments/mercadopago/create-preference', {
        participante_id: participanteId
      });

      if (response.data?.init_point) {
        window.location.href = response.data.init_point;
      } else {
        alert('Erro ao processar. Por favor, entre em contato conosco.');
      }
    } catch (error) {
      console.error('Error retrying payment:', error);
      // Ensure errorMessage is always a string
      let errorMessage = 'Erro ao processar. Por favor, entre em contato conosco.';
      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        errorMessage = typeof detail === 'string' ? detail : errorMessage;
      }
      alert(errorMessage);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center p-4" data-testid="pagamento-erro-page">
      <div className="max-w-lg w-full text-center">
        {/* Error Icon */}
        <div className="w-24 h-24 mx-auto mb-8 rounded-full bg-red-500/20 flex items-center justify-center">
          <XCircle className="w-12 h-12 text-red-500" />
        </div>

        <h1 className="font-display text-3xl md:text-4xl text-white mb-4">
          Pagamento Não Concluído
        </h1>

        <p className="text-gray-400 text-lg mb-8">
          Infelizmente não foi possível processar seu pagamento. Isso pode acontecer por diversos motivos.
        </p>

        <div className="bg-white/5 border border-white/10 rounded-xl p-6 mb-8">
          <h3 className="text-white font-semibold mb-4">Possíveis causas:</h3>
          <ul className="text-left text-gray-400 space-y-3">
            <li className="flex items-start gap-3">
              <span className="text-red-500 mt-1">•</span>
              <span>Cartão recusado pela operadora</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-red-500 mt-1">•</span>
              <span>Saldo insuficiente</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-red-500 mt-1">•</span>
              <span>Dados do cartão incorretos</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-red-500 mt-1">•</span>
              <span>Pagamento cancelado pelo usuário</span>
            </li>
          </ul>
        </div>

        <div className="space-y-4">
          <p className="text-gray-500 text-sm">
            Você pode tentar novamente escolhendo outro método de pagamento.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {participanteId ? (
              <Button 
                onClick={handleRetry}
                className="bg-kairos-orange hover:bg-kairos-orange-dark text-white px-8"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Tentar Novamente
              </Button>
            ) : null}
            
            <Link to="/">
              <Button variant="outline" className="border-white/20 text-gray-300 hover:bg-white/5">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Voltar ao Início
              </Button>
            </Link>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-gray-500 text-sm">
            Precisa de ajuda? Entre em contato pelo WhatsApp: (69) 99999-9999
          </p>
        </div>
      </div>
    </div>
  );
};

export default PagamentoErroPage;
